import Vue from 'vue';
import Vuex from 'vuex';
import { isMobile, deepAssign } from './utils';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMobile: isMobile(),
    user: null,          // the signed-in account: { id, displayName, email }
    sessionId: null,
    authChecked: false,
    site: {},            // the site's public information (GET /api/site): { icpLicense, testSite }
  },

  mutations: {
    set(state, up) {
      deepAssign(state, up)
    }
  }
});
